import { IAttributes, IAugmentedJQuery, IScope, INgModelController } from 'angular';
import { DirectiveUsingNgModelController } from './directive.types';

const directiveName = 'percent';

export function percent(): DirectiveUsingNgModelController {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: (_scope: IScope, _element: IAugmentedJQuery, attributes: IAttributes, ctrl: INgModelController) => {
      ctrl.$parsers.push((value) => {
        if (ctrl.$isEmpty(value)) return undefined;
        return Number((Number(value) / 100).toFixed(attributes.decimals + 2));
      });
      ctrl.$formatters.unshift((value) => {
        if (ctrl.$isEmpty(value)) return undefined;
        const num = Number(value);
        if (Number.isNaN(num)) return undefined;
        return (num * 100).toFixed(attributes.decimals || 0);
      });
    },
  };
}

export const ngPercentDirective = {
  [directiveName]: percent,
};
